export default class JobsPhotoGrid {
    photos = [];
    isLoadGrid = false;

    constructor() {
        this.init();
    }

    init() {
        if (this.photos.length === 0) {
            this.photos = document.querySelectorAll('.js-get-photo-list-wrapper') || [];
        }

        let gridLoader = setInterval((e) => {
            if (this.photos.length > 0) {
                this.loadGrid();
                clearInterval(gridLoader);
            }
        }, 100)

        this.reloadGrid();
    }

    loadGrid() {
        this.photos.forEach((wrapper) => {
            let list = wrapper.querySelectorAll('img');
            if (list.length > 0) {
                list.forEach((l) => {
                    l.classList.remove('active');
                })
                let ind = this.getRandom(0, list.length - 1);
                let photo = list[ind] || list[0];
                photo.classList.add('active');
            }
        })
        this.isLoadGrid = true;
    }

    reloadGrid() {
        setInterval(() => {
            if (this.photos.length > 0 && this.isLoadGrid) {
                this.photos.forEach((wrapper) => {
                    let list = wrapper.querySelectorAll('img');
                    if (list.length > 0) {
                        let timeout = this.getRandom(1, 10) * 100;
                        let active = Array.from(list).filter((el) => el.classList.contains('active'));
                        active = active[0];
                        setTimeout(() => {
                            list.forEach((l) => {
                                l.classList.remove('active');
                            })
                            let ind = this.getUniqRand([active.dataset.ind - 1], list.length - 1);
                            let photo = list[ind] || list[0];
                            photo.classList.add('active');
                        }, timeout)
                    }
                })
            }
        }, 3500)
    }

    getUniqRand(loaded, length) {
        let rndPhoto = this.getRandom(1, length);
        if (loaded.includes(rndPhoto)) {
            return this.getUniqRand(loaded, length);
        }
        loaded.push(rndPhoto);
        return rndPhoto;
    }

    getRandom(min, max) {
        let rand = min + Math.random() * (max + 1 - min);
        return Math.floor(rand);
    }
}
